/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Essay_TitleInputs */

const en_pc_cmp_essay_title = /** @type {(inputs: Pc_Cmp_Essay_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is PdfCraft a good Adobe Acrobat alternative?`)
};

const zh_pc_cmp_essay_title = /** @type {(inputs: Pc_Cmp_Essay_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PdfCraft 是好的 Adobe Acrobat 替代品吗？`)
};

/**
* | output |
* | --- |
* | "Is PdfCraft a good Adobe Acrobat alternative?" |
*
* @param {Pc_Cmp_Essay_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_essay_title = /** @type {((inputs?: Pc_Cmp_Essay_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Essay_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_essay_title(inputs)
	return zh_pc_cmp_essay_title(inputs)
});
export { pc_cmp_essay_title as "pc.cmp.essay_title" }